import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

const FiftyFiftySlider = () => {
    const init = () => {
        const carousels = document.querySelectorAll('.fifty-fifty-hero__carousel.swiper');
        if (!carousels.length) return;

        carousels.forEach((carousel) => {
            const slides = carousel.querySelectorAll('.swiper-slide');
            const prevButton = carousel.querySelector('.swiper-pagination__button-prev');
            const nextButton = carousel.querySelector('.swiper-pagination__button-next');
            const toggleButton = carousel.querySelector('[data-carousel-toggle]');

            const swiper = new Swiper(carousel, {
                modules: [Autoplay],
                slidesPerView: 1,
                spaceBetween: 0,
                centeredSlides: false,
                loop: slides.length > 1,
                autoHeight: true,
                autoplay: slides.length > 1 ? {
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                } : false,
            });

            if (prevButton && nextButton) {
                const updateButtonStates = () => {
                    if (slides.length <= 1) {
                        prevButton.disabled = true;
                        nextButton.disabled = true;
                        prevButton.classList.add('swiper-button-disabled');
                        nextButton.classList.add('swiper-button-disabled');
                        return;
                    }

                    prevButton.disabled = !swiper.params.loop && swiper.isBeginning;
                    nextButton.disabled = !swiper.params.loop && swiper.isEnd;
                    prevButton.classList.toggle('swiper-button-disabled', prevButton.disabled);
                    nextButton.classList.toggle('swiper-button-disabled', nextButton.disabled);
                };

                prevButton.addEventListener('click', () => swiper.slidePrev());
                nextButton.addEventListener('click', () => swiper.slideNext());
                updateButtonStates();
                swiper.on('slideChange', updateButtonStates);
            }

            if (toggleButton) {
                const updateToggleState = () => {
                    const isRunning = !!(swiper.autoplay && swiper.autoplay.running);

                    toggleButton.textContent = isRunning ? 'Pause' : 'Play';
                    toggleButton.setAttribute('aria-pressed', isRunning ? 'false' : 'true');

                    if (slides.length <= 1) {
                        toggleButton.disabled = true;
                    }
                };

                toggleButton.addEventListener('click', () => {
                    if (!swiper.autoplay || slides.length <= 1) return;

                    if (swiper.autoplay.running) {
                        swiper.autoplay.stop();
                    } else {
                        swiper.autoplay.start();
                    }

                    updateToggleState();
                });

                updateToggleState();
            }
        });
    };

    return {
        init
    };
};

export default FiftyFiftySlider;
